export class RealtorRegModel {
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    city: string;
    zip: string;
    state: string;
    mlsAffiliation: string;
    licenseNumber: string;
    licenseState: string;
    licenseExpiration: string;
    email: string;
    phone: string;
    companyName: string;
    companyUrl: string;
    password: string;
    type: number;
    paymentMethodNonce: string;
    MembershipPlan: string;
    HeaderColorHex: string;
    promoCode: string;
  preferredTms: any;
  emergencyContactName: string;
emergencyContactNumber: string;
emergencyContactName2: string;
emergencyContactNumber2: string;
emergencyContactName3: string;
emergencyContactNumber3: string;
emergencyContactName4: string;
emergencyContactNumber4: string;
emergencyContactName5: string;
emergencyContactNumber5: string;
}